import Component from '../abstracts/Component';
import NewsletterLogic from '../logics/NewsletterLogic';

export default class FooterNewsletterComponent extends Component {
  get SELECTORS() {
    return {
      newsletterBox: '.c-newsletter-footer ',
      label: '.form-newsletter-label',
      form: '.js-newsletter-form',
      jsContent: '.js-modal-form-contents',
      input: '[data-newsletter-f-input]',
      emailInput: '[data-newsletter-f-input]',
      inputBox: '.input-newsletter',
      hiddenBlock: '[data-newsletter-f-hidden]',
      submitButton: '.js-nl-submission',
      checkSubmitBtns: '.check-submit',
      privacyCheckbox: '#privacy-news-footer',
      intrendCheckbox: '#privacy-intrend-footer',
      formWrapper: '.news-f__form__input',
      errorSubscribed: '.error-already-subscribed',
      errorPrivacy: '.error-privacy-invalid',
      errorEmail: '.error-email-invalid',
      errorGeneric: '.error-generic',
      newsletterWrapper: '.register',
      newslettersuccess: '.news-f__success',
    };
  }

  get CLASSES() {
    return {
      success: 'success',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.input = this.$component.querySelector(this.SELECTORS.input);
    this.label = this.$component.querySelector(this.SELECTORS.label);
    this.inputBox = this.$component.querySelector(this.SELECTORS.inputBox);
    this.hiddenBlock = this.$component.querySelector(this.SELECTORS.hiddenBlock);
    this.checkSubmitBtns = this.$component.querySelectorAll(this.SELECTORS.checkSubmitBtns);
    this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.intrendCheckbox = this.$component.querySelector(this.SELECTORS.intrendCheckbox);
    this.newsletterBox = this.$component.querySelector(this.SELECTORS.newsletterBox);
    this.formWrapper = this.$component.querySelector(this.SELECTORS.formWrapper);
    this.errorSubscribed = this.$component.querySelector(this.SELECTORS.errorSubscribed);
    this.errorPrivacy = this.$component.querySelector(this.SELECTORS.errorPrivacy);
    this.errorEmail = this.$component.querySelector(this.SELECTORS.errorEmail);
    this.errorGeneric = this.$component.querySelector(this.SELECTORS.errorGeneric);
    this.newsletterWrapper = this.$component.querySelector(this.SELECTORS.newsletterWrapper);
    this.newslettersuccess = this.$component.querySelector(this.SELECTORS.newslettersuccess);
}

  listenInput() {
    this.input.addEventListener('focus', () => {
      this.hiddenBlock.classList.add('show');
      this.checkSubmit();
    });

  }

  checkSubmit() {
    // enable submit
    if (this.checkSubmitBtns != null) {
      this.checkSubmitBtns.forEach((checkbox, index) => {
        checkbox.addEventListener('click', e => {

          checkbox.toggleAttribute('checked');
        });
      });
    }
  }

  bindEvents() {
    
    let ctx = this;
    //
    this.$on(this.$customEvents.NL_FOOTER_EVENTS.subscribed, ({ event, payload }) => {
        // go logic
        this.NewsletterLogic.sendFromFooter(ctx);
    });

    this.$on('submit.js-nl-submission', this.NewsletterLogic.subscribeToNewsletter, this.SELECTORS.newsletterBox, this.SELECTORS.form, this);

}

  inputChange() {
        
    this.input.addEventListener('change',(e) => {
            var valueLength = this.input.value.length;
            if (valueLength > 0 ) {
                this.label.classList.add('freeze');
            } else {
                this.label.classList.remove('freeze');
            }
        })
    }
    
    render() {
    
    this.inputChange();

    super.render();
    this.listenInput();
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
    // go events
    this.bindEvents();
  }

}
